module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Equalizer-8eae80619cc3ecb81808338347363b88.svg";